import { render } from "./DashboardMoatComps.vue?vue&type=template&id=b7dce258"
import script from "./DashboardMoatComps.vue?vue&type=script&lang=js"
export * from "./DashboardMoatComps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__